import React from 'react';
import PropTypes from 'prop-types';

import CountBadge from "../../../../OrderTable/components/OrderRow/components/OrderNotes/components/CountBadge";
import IconContainer from "../../../../OrderTable/components/OrderRow/components/OrderNotes/components/IconContainer";

import {ReactComponent as CustomerCommentSvg} from "assets/img/customer-comment.svg";
import {ReactComponent as InternalNoteSvg} from "assets/img/internalNote-green.svg";

MobileOrderNotes.propTypes = {
    customerCommentCount: PropTypes.number,
    internalNoteCount: PropTypes.number
};

function MobileOrderNotes({customerCommentCount = 0, internalNoteCount = 0}) {
    if (customerCommentCount === 0 && internalNoteCount === 0) {
        return null;
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'center'
        }}>
            {customerCommentCount > 0 && (
                <IconContainer>
                    <CountBadge count={customerCommentCount} />
                    <CustomerCommentSvg />
                </IconContainer>
            )}
            {internalNoteCount > 0 && (
                <IconContainer>
                    <CountBadge count={internalNoteCount} />
                    <InternalNoteSvg />
                </IconContainer>
            )}
        </div>
    );
}

export default MobileOrderNotes;
